import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2 p-4 relative min-h-300" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg" }, " Fill the details for attached mail ", -1)
const _hoisted_3 = { class: "flex flex-col gap-1 w-full" }
const _hoisted_4 = { class: "flex justify-end gap-3 w-full items-center" }
const _hoisted_5 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_6 = { class: "flex items-center gap-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Attach File", -1)
const _hoisted_8 = { class: "ml-auto" }
const _hoisted_9 = { class: "flex items-center gap-5 justify-center mt-auto" }

import {
	Dialog,
	UiButton,
	SvgIcon,
	UiSelect,
	UiLoader,
	UiFormError,
	UiForm,
	UiInput,
	UiFileUpload,
	useForm
} from '@/ui-kit';
import { useToggle } from '@vueuse/core';
import { computed, ref } from 'vue';
import { AxiosError } from 'axios';
import { Nullable, httpService, toFormData } from '@/utils';
import { required } from '@vuelidate/validators';
import { useToast } from 'vue-toastification';
import filesize from 'filesize';


export default /*#__PURE__*/_defineComponent({
  __name: 'UploadMailDialog',
  props: {
    mailboxId: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
	mailboxId: number;
};

const [isOpened, setIsOpened] = useToggle();



const error = ref('');

const onError = (e: AxiosError) => {
	if (!e.response || !e.response.data) {
		return;
	}

	if (e.response.data.error || e.response.data.message) {
		error.value =
			e.response.data.error ||
			e.response.data.message;
	}

	if (e.response.data.errors) {
		error.value = e.response.data.message || '';
	}
};

const { formData, loading, resetForm, onSubmit } = useForm(
	{
		control_number: '',
		recipient: '',
		document_type: 'CORRESPONDENCE',
		document_file: null as Nullable<File>
	},
	{
		control_number: {
			required
		},
		recipient: {
			required
		},
		document_type: {
			required
		},
		document_file: {
			required
		}
	}
);

const { success } = useToast();

const submit = onSubmit(async (data) => {
	const response = await httpService.post<{
		message: string;
	}>(
		`company/virtual-mailbox/items/${props.mailboxId}/mails`,
		toFormData(data)
	);
	setIsOpened(false);
	success(response.message);
});

expose({
	openDialog: async () => {
		error.value = '';
		resetForm({});
		setIsOpened(true);
	}
});

const fileData = computed(() => {
	if (!formData.document_file) {
		return '';
	}

	return `${formData.document_file.name} (${filesize(
		formData.document_file.size
	)})`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    preventDefaultClose: _unref(loading),
    modelValue: _unref(isOpened),
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_unref(setIsOpened)(false)))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(UiForm), { onSubmit: _unref(submit) }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createVNode(_unref(UiInput), {
              modelValue: _unref(formData).control_number,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).control_number) = $event)),
              name: "control_number",
              placeholder: "Control number",
              label: "the VMB identifier of file",
              disabled: _unref(loading)
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode(_unref(UiInput), {
              modelValue: _unref(formData).recipient,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formData).recipient) = $event)),
              name: "recipient",
              placeholder: "Recipient",
              label: "Name of receiver",
              disabled: _unref(loading)
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode(_unref(UiSelect), {
              label: "Document type",
              modelValue: _unref(formData).document_type,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formData).document_type) = $event)),
              disabled: _unref(loading),
              options: [
						{
							value: 'CORRESPONDENCE',
							title: 'Correspondence'
						},
						{
							value: 'CHECKS',
							title: 'Checks'
						}
					],
              name: "document_type",
              placeholder: "Document type"
            }, null, 8, ["modelValue", "disabled"]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (_unref(fileData))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(fileData)), 1))
                  : _createCommentVNode("", true),
                _createVNode(_unref(UiFileUpload), {
                  accept: "application/pdf",
                  name: "document_file",
                  disabled: _unref(loading),
                  multiple: false,
                  modelValue: _unref(formData).document_file,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formData).document_file) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(UiButton), {
                      tabindex: "0",
                      theme: "primary-outlined",
                      class: "!min-w-8 !px-2 !h-8 hover:bg-dark-blue-400 hover:bg-opacity-20 transparent",
                      disabled: _unref(loading),
                      type: "button"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_unref(SvgIcon), {
                            name: "attach-file",
                            class: "h-5 w-5"
                          }),
                          _hoisted_7
                        ])
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }, 8, ["disabled", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_unref(UiFormError), {
                  name: "document_file",
                  label: "Document file"
                })
              ])
            ]),
            _createVNode(_unref(UiFormError), { errorMessage: error.value }, null, 8, ["errorMessage"]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_unref(UiButton), {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(setIsOpened)(false))),
                theme: "secondary",
                type: "button",
                class: "!text-sm !h-10 !min-w-20 w-32 !px-0",
                disabled: _unref(loading)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Cancel ")
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_unref(UiButton), {
                class: "!text-sm !h-10 !min-w-20 w-32 !px-0",
                loading: _unref(loading)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Upload Mail ")
                ]),
                _: 1
              }, 8, ["loading"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ]),
    _: 1
  }, 8, ["preventDefaultClose", "modelValue"]))
}
}

})